export const DOWNGRADE_URLS = {
  getDowngradeDetails: '/store/v1/changePlan/getChangePlanDetails',
  switchAndExtend: '/store/v1/changePlan/switchAndExtend',
  switchAndRefund: '/store/v1/changePlan/switchAndRefund',
  switchInGracePeriod: '/store/v1/changePlan/switchInGracePeriod'
};
//# sourceMappingURL=consts.js.map